import { PAGE_NAME } from '../constants';

export const stringToAnchor = (str) => `#${str.toLowerCase().replace(/[\W_^-]+/g, '-')}`;
export const toStats = (...keys) => ['services', PAGE_NAME, ...keys].join('.');
